<template>
    <div>
        <v-card class="mt-5"
            ><v-card-title>
                <v-toolbar color="indigo" dense>
                    <v-toolbar-title class="white--text"
                        >Lista azioni</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="
                                    id_report = -1;
                                    dialog_nuova_azione = true;
                                    titolo_finestra = 'Nuova azione';
                                "
                                small
                                v-bind="attrs"
                                v-on="on"
                                class="mr-5"
                            >
                                <v-icon color="primary">mdi-plus</v-icon>
                            </v-btn>
                        </template>
                        <span>Aggiungi azione</span>
                    </v-tooltip>
                    <v-spacer></v-spacer>
                </v-toolbar>
            </v-card-title>
            <v-data-table
                height="30vh"
                fixed-header
                :headers="headers"
                :items="lista_azioni"
            >
                <!-- Colonna allegati -->
                <template v-slot:[`item.allegati`]="{ item }">
                    <v-btn @click="apriAllegati(item)" small
                        ><v-icon color="primary">mdi-paperclip</v-icon></v-btn
                    >
                </template>
                <!-- Colonna del modifica -->
                <template v-slot:[`item.modifica`]="{ item }">
                    <v-btn
                        @click="
                            dialog_nuova_azione = true;
                            modifica(item);
                            titolo_finestra = 'Modifica azione';
                        "
                        small
                        ><v-icon color="primary">mdi-pencil</v-icon></v-btn
                    >
                </template>

                <!-- Colonna dell'elimina -->
                <template v-slot:[`item.delete`]="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="elimina(item)"
                                small
                                v-bind="attrs"
                                v-on="on"
                                ><v-icon color="error"
                                    >mdi-delete</v-icon
                                ></v-btn
                            >
                        </template>
                        <span>Elimina</span>
                    </v-tooltip>
                </template>
            </v-data-table>
        </v-card>

        <v-dialog class="ma-0 pa-0" v-model="allegatiVisible" width="90vw">
            <v-card
                class="ma-0 pa-0"
                height="calc(100vh - 100px)"
                style="overflow: hidden"
            >
                <div style="position: relative; height: 100%">
                    <WindowFrame
                        class="ma-0 pa-0"
                        referrerpolicy="origin"
                        @click_chiudi="allegatiVisible = false"
                        :component="'allegati'"
                        ref="windowframe_allegati"
                        :input_args="inputArgs"
                        :key="keyAllegati"
                    />
                </div>
            </v-card>
        </v-dialog>

        <!-- Dialog di aggiunta azione -->
        <v-dialog v-model="dialog_nuova_azione" width="unset">
            <v-card min-width="600px">
                <v-toolbar
                    class="white--text"
                    color="indigo"
                    style="position: sticky; top: 0px; z-index: 1"
                    dense
                >
                    <v-toolbar-title>{{ titolo_finestra }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <!-- Bottone di salvataggio -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="
                                    salvaAzione();
                                    dialog_conferma_salva = false;
                                "
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="success"> mdi-floppy </v-icon>
                            </v-btn>
                        </template>
                        <span>Salva</span>
                    </v-tooltip>
                    <v-spacer></v-spacer>
                    <!-- Bottone di chiusura -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="
                                    dialog_nuova_azione = false;
                                    pulisciAzioni();
                                "
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="error"> mdi-close </v-icon>
                            </v-btn>
                        </template>
                        <span>Annulla</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text class="mt-5 mb-0 pb-5">
                    <v-row align="center" justify="start" class="ml-5">
                        <v-col cols="6">
                            <v-autocomplete
                                background-color="#ffffff"
                                hide-details
                                :items="lista_tipi_azione"
                                :item-text="(e) => e.descrizione"
                                item-value="id_evento_tipo_azione"
                                label="Tipo azione"
                                v-model="id_tipo_azione"
                            >
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="6">
                            <v-autocomplete
                                v-if="id_tipo_azione == 5"
                                background-color="#ffffff"
                                hide-details
                                :items="reports"
                                item-text="cod_label"
                                item-value="id_label"
                                label="Modello Report"
                                v-model="id_report"
                            >
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row align="center" justify="start" class="ml-5">
                        <v-col cols="4">
                            <v-radio-group
                                v-model="tipo_dest"
                                dense
                                label="Tipo destinatario"
                            >
                                <v-radio
                                    v-for="(item, index) in this
                                        .lista_tipi_dest"
                                    :key="index"
                                    :label="`${item.descrizione}`"
                                    :value="item.descrizione"
                                ></v-radio>
                            </v-radio-group>
                        </v-col>
                        <v-col cols="6" v-if="tipo_dest == 'Profilo'">
                            <v-autocomplete
                                background-color="#ffffff"
                                hide-details
                                :items="lista_profili"
                                :item-text="(e) => e.des_profilo_utente"
                                item-value="id_profilo_utente"
                                label="Profilo"
                                multiple
                                v-model="lista_id_profilo"
                            >
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="6" v-if="tipo_dest == 'Persona'">
                            <v-autocomplete
                                background-color="#ffffff"
                                hide-details
                                :items="lista_vis_utenti"
                                :item-text="(e) => e.cognome"
                                item-value="id_personale"
                                label="Persona"
                                multiple
                                v-model="lista_id_persona"
                            >
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row class="ml-5 mb-5" align="center" justify="start">
                        <v-col cols="4">
                            <v-autocomplete
                                background-color="#ffffff"
                                hide-details
                                :items="modalita_messaggio"
                                label="Messaggio"
                                v-model="query_messaggio"
                            >
                            </v-autocomplete>
                        </v-col>
                        <v-col
                            cols="6"
                            v-if="query_messaggio == 'Query standard'"
                        >
                            <v-autocomplete
                                background-color="#ffffff"
                                hide-details
                                :items="lista_query_standard"
                                :item-text="(e) => e.titolo"
                                item-value="query1[0].query"
                                label="Query standard"
                                v-model="query_standard_mex"
                            >
                            </v-autocomplete>
                        </v-col>
                        <v-col
                            cols="6"
                            v-if="query_messaggio == 'Query libera'"
                        >
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        @click="dialog_query_libera = true"
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        class="mr-5"
                                    >
                                        Inserisci query
                                    </v-btn>
                                </template>
                                <span></span>
                            </v-tooltip>
                        </v-col>
                        <v-col cols="6" v-if="query_messaggio == 'Testo'">
                            <v-text-field
                                background-color="#ffffff"
                                label="Messaggio di testo"
                                v-model="mex_testo"
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Dialog query libera -->
        <v-dialog v-model="dialog_query_libera" width="unset">
            <v-card min-width="600px">
                <v-toolbar
                    class="white--text"
                    color="indigo"
                    style="position: sticky; top: 0px; z-index: 1"
                    dense
                >
                    <v-toolbar-title>Query libera</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <!-- Bottone di chiusura -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="dialog_query_libera = false"
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="error"> mdi-close </v-icon>
                            </v-btn>
                        </template>
                        <span>Annulla</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text class="mt-5 mb-0 pb-5">
                    <QueryMessaggio
                        :query_mod="query_libera_mex"
                        ref="queryMex"
                    />
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- Snackbar -->
        <SnackbarQV ref="SnackbarQV" />
    </div>
</template>

<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";
import QueryMessaggio from "@/components/QNOTICE/QueryMessaggio.vue";

export default {
    name: "Azione",
    components: { SnackbarQV, QueryMessaggio, WindowFrame },
    props: ["selez", "nuovo"],
    data() {
        return {
            allegatiVisible: false,
            inputArgs: {
                cod_riferimento: "t_eventi_azioni",
                id_riferimento: -1,
                pk_riferimento: "id_evento_azione",
                id_utente: localStorage.id,
            },
            keyAllegati: true,
            // Variabili di supporto
            id_report: -1,
            selez_az: null,
            tipo_dest: "",
            query_messaggio: "",
            query_standard_mex: "",
            query_libera_mex: "",
            mex_testo: "",
            id_tipo_azione: null,
            titolo_finestra: "Nuova azione",
            id_evento_azione: null,
            id_evento_destinatario: null,

            // Modali
            dialog_modifica_ev: false,
            dialog_nuova_azione: false,
            dialog_query_libera: false,

            // Array
            reports: [],
            lista_id_profilo: [],
            lista_id_persona_da_BE: [],
            lista_id_persona: [],
            modalita_messaggio: ["Query standard", "Query libera", "Testo"],
            lista_query_standard: [],
            headers: [
                {
                    text: "Modifica",
                    sortable: false,
                    value: "modifica",
                    class: "",
                },
                {
                    text: "Allegati",
                    sortable: false,
                    value: "allegati",
                    class: "",
                },
                {
                    text: "Tipo",
                    sortable: false,
                    value: "azione",
                    class: "",
                },
                {
                    text: "Destinatari",
                    sortable: false,
                    value: "destinatari_lista",
                    class: "",
                },
                {
                    text: "Elimina",
                    sortable: false,
                    value: "delete",
                    class: "",
                },
            ],
            lista_azioni: [],
            lista_persone: [],
            lista_profili: [],
            lista_tipi_dest: [],
            lista_tipi_azione: [],
        };
    },

    methods: {
        apriAllegati(item) {
            console.log(item);
            this.inputArgs.id_riferimento = item.id_evento_azione;
            this.allegatiVisible = true;
            this.keyAllegati = !this.keyAllegati;
        },
        elimina(item) {
            var request = {
                controller: "notice",
                method: "PUT",
                richiesta: {
                    action: "saveeventoazionevalidita",
                    token: localStorage.getItem("user_token"),
                    evento_azione: {
                        id_evento_azione: item.id_evento_azione,
                        validita: 0,
                    },
                },
            };

            this.$store
                .dispatch("api6", request)
                .then((res) => {
                    if (res.status == 200 || res.status == 204) {
                        console.log("Eliminato");
                        this.getAzioniEvento();
                    }
                })
                .catch((err) => {
                    console.log("ERRORE");
                    console.log(err);
                });
        },
        getReports() {
            var request = {
                controller: "Label",
                method: "POST",
                richiesta: {
                    action: "getreport",
                    token: localStorage.getItem("user_token"),
                },
            };

            this.$store
                .dispatch("api", request)
                .then((res) => {
                    this.reports = res.data;
                })
                .catch(() => {
                    this.overlay = false;
                    this.$refs.SnackbarQV.print("error", "Errore");
                });
        },
        getAzioniEvento() {
            var request = {
                controller: "notice",
                method: "POST",
                richiesta: {
                    action: "geteventiall",
                    token: localStorage.getItem("user_token"),
                },
            };

            this.$store
                .dispatch("api6", request)
                .then((res) => {
                    if (res.status == 200) {
                        let eventi = res.data.result;
                        eventi.forEach((item) => {
                            if (
                                item.id_evento == this.selez.id_evento &&
                                item.azioni != null
                            ) {
                                this.lista_azioni = JSON.parse(item.azioni);
                            }
                        });
                        console.log(this.lista_azioni);
                        this.lista_azioni.forEach((az) => {
                            az.destinatari_lista = "";
                            if (az.destinatari != null) {
                                az.destinatari = JSON.parse(az.destinatari);
                                az.destinatari.forEach((dest) => {
                                    az.destinatari_lista =
                                        az.destinatari_lista +
                                        dest.destinatario +
                                        ", ";
                                });
                            }
                            console.log("Lista: ", az.destinatari_lista);
                        });
                    }
                })
                .catch((err) => {
                    console.log("ERRORE");
                    console.log(err);
                });
        },
        getPersonale() {
            let request = {
                controller: "notice",
                method: "POST",
                richiesta: {
                    action: "getutenti",
                    token: localStorage.getItem("user_token"),
                },
            };

            this.$store
                .dispatch("api6", request)
                .then((res) => {
                    if (res.status === 200) {
                        this.lista_persone = res.data.result ? res.data.result : [];
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, impossibile caricare i dati."
                        );
                    }
                })

                .catch((e) => {
                    console.error(e);
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, impossibile caricare i dati."
                    );
                });
        },

        getProfili() {
            let request = {
                controller: "notice",
                method: "POST",
                richiesta: {
                    action: "getprofili",
                    token: localStorage.getItem("user_token"),
                },
            };

            this.$store
                .dispatch("api6", request)
                .then((res) => {
                    if (res.status === 200) {
                        this.lista_profili = res.data.result ? res.data.result : [];
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, impossibile caricare i dati."
                        );
                    }
                })

                .catch((e) => {
                    console.error(e);
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, impossibile caricare i dati."
                    );
                });
        },

        getQueryStandard() {
            let request = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "getquerydettaglio",
                    token: localStorage.user_token,
                },
            };

            this.$store.dispatch("api", request).then((res) => {
                this.overlay = false;
                if (res.data.result.query.length != 0) {
                    this.lista_query_standard = res.data.result.query;
                } else {
                    console.log("Non ci sono query.");
                }
            });
        },

        // Popolo la lista dei tipi di destinatari
        getTipi() {
            var request = {
                controller: "notice",
                method: "POST",
                richiesta: {
                    action: "geteventitipidestinatari",
                    token: localStorage.getItem("user_token"),
                },
            };

            this.$store
                .dispatch("api6", request)
                .then((res) => {
                    if (res.status == 200) {
                        this.lista_tipi_dest = res.data.result;
                    }
                })
                .catch((err) => {
                    console.log("ERRORE");
                    console.log(err);
                });
        },

        getTipiAzione() {
            var request = {
                controller: "notice",
                method: "POST",
                richiesta: {
                    action: "geteventitipiazione",
                    token: localStorage.getItem("user_token"),
                },
            };

            this.$store
                .dispatch("api6", request)
                .then((res) => {
                    if (res.status == 200) {
                        this.lista_tipi_azione = res.data.result;
                        console.log("tipi azione", this.lista_tipi_azione)
                    }
                })
                .catch((err) => {
                    console.log("ERRORE");
                    console.log(err);
                });
        },

        modifica(item) {
            console.log("modifica", item)
            // Chiamate per avere tipo azione e destinatari

            this.id_evento_azione = item.id_evento_azione;
            if (item.is_query == 0) {
                this.query_messaggio = "Testo";
                this.mex_testo = item.query_messaggio;
            } else if (item.is_query == 1) {
                this.query_messaggio = "Query libera";
                this.query_libera_mex = item.query_messaggio;
                console.log("query_mod: ", this.query_libera_mex);
            }

            this.lista_id_persona = [];
            this.lista_id_profilo = [];

            if (item.destinatari != null) {
                item.destinatari.forEach((i) => {
                    if (i.is_profilo == 0) {
                        this.tipo_dest = "Persona";
                        this.lista_id_persona.push(i.id_destinatario);
                    } else if (i.is_profilo == 1) {
                        this.tipo_dest = "Profilo";
                        if (
                            !this.lista_id_profilo.includes(i.id_destinatario)
                        ) {
                            this.lista_id_profilo.push(i.id_destinatario);
                        }
                    }
                });
            }else{
                this.tipo_dest = "Dinamici";
            }
            //console.log(this.lista_id_persona);
            //console.log(this.lista_id_profilo);

            var request1 = {
                controller: "notice",
                method: "POST",
                richiesta: {
                    action: "geteventiazioni",
                    //id_evento: null,
                    id_evento_azione: item.id_evento_azione,
                    token: localStorage.getItem("user_token"),
                },
            };

            this.$store
                .dispatch("api6", request1)
                .then((res) => {
                    if (res.status == 200) {
                        this.id_tipo_azione = res.data.result[0].id_azione;
                        this.id_report = res.data[0].id_report;
                        console.log(this.id_tipo_azione);
                    }
                })
                .catch((err) => {
                    console.log("ERRORE");
                    console.log(err);
                });

            // Popolare i dati della schermata di nuovo/modifica
            console.log(item);
            /*       this.profilo = "";
      this.persona = "";
      this.query_standard_mex = "";
      this.mex_testo = "";
      this.id_tipo_azione = null; */
        },

        // Ripulisco le variabili se esco dal dialog di nuova azione
        pulisciAzioni() {
            this.tipo_dest = "";
            this.profilo = "";
            this.persona = "";
            this.query_standard_mex = "";
            this.query_messaggio = "";
            this.mex_testo = "";
            this.id_tipo_azione = null;
            this.lista_id_profilo = [];
            this.lista_id_persona = [];
            this.id_evento_azione = null;
            this.id_evento_destinatario = null;
        },

        salvaAzione() {
            if(this.id_tipo_azione == null || this.tipo_dest == ""){
                this.$refs.SnackbarQV.print(
                            "error",
                            "Compilare tipo azione e destinatario"
                        );
                return;
            }
            // Scelgo la query per il messaggio in base al tipo
            let query_mex_save = "";
            let e_query_messaggio = null;

            if (this.query_messaggio != "") {
                e_query_messaggio = 1;
                if (this.query_messaggio == "Query standard") {
                    query_mex_save = this.query_standard_mex;
                } else if (this.query_messaggio == "Testo") {
                    query_mex_save = this.mex_testo;
                    e_query_messaggio = 0;
                } else if (this.$refs.queryMex != null) {
                    query_mex_save = this.$refs.queryMex.query_mex.query;
                    console.log("Query libera: ", query_mex_save);
                }
            }

            // Vedo se profili o persone
            let is_profilo = 0;
            let lista_destinatari = [];

            if (this.tipo_dest == "Profilo") {
                is_profilo = 1;
                for (let i = 0; i < this.lista_id_profilo.length; i++) {
                    lista_destinatari[i] = {};
                    lista_destinatari[i].id_evento_destinatario = null;
                    lista_destinatari[i].is_profilo = is_profilo;
                    lista_destinatari[i].id_destinatario =
                        this.lista_id_profilo[i];
                }
            }

            if (this.tipo_dest == "Persona") {
                for (let i = 0; i < this.lista_id_persona.length; i++) {
                    console.log(this.lista_id_persona[i]);
                    lista_destinatari[i] = {};
                    lista_destinatari[i].id_evento_destinatario = null;
                    lista_destinatari[i].is_profilo = is_profilo;
                    lista_destinatari[i].id_destinatario =
                        this.lista_id_persona[i];
                }
            }

            console.log(lista_destinatari);

            var request = {
                controller: "notice",
                method: "PUT",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "saveeventoazionedestinatari",

                    evento_azione: [{
                        id_evento_azione: this.id_evento_azione,
                        id_evento: this.selez.id_evento,
                        id_azione: this.id_tipo_azione,
                        id_report: this.id_report,
                        is_query: e_query_messaggio,
                        query_messaggio: query_mex_save,
                        validita: 1,
                        destinatari: lista_destinatari,
                    }],
                },
            };

            this.$store
                .dispatch("api6", request)
                .then((res) => {
                    if (res.status == 200) {
                        this.getAzioniEvento();
                        this.$refs.SnackbarQV.print(
                            "success",
                            "Salvataggio effettuato."
                        );
                        this.dialog_nuova_azione = false;
                        this.pulisciAzioni();
                    }
                })
                .catch((err) => {
                    console.log("ERRORE");
                    console.log(err);
                });
        },
    },

    computed: {
        lista_vis_utenti() {
            let lista_visualizzata = [];
            if (this.id_tipo_azione == 2) {
                lista_visualizzata = this.lista_persone.filter(
                    (e) => e.cellulare != ""
                );
            } else if (this.id_tipo_azione == 1 || this.id_tipo_azione == 3) {
                lista_visualizzata = this.lista_persone.filter(
                    (e) => e.email != ""
                );
            }
            console.log(lista_visualizzata);
            return lista_visualizzata;
        },
    },

    watch: {},

    mounted() {
        if (!this.nuovo) {
            this.getAzioniEvento();
            this.getPersonale();
            this.getProfili();
            this.getTipi();
            this.getTipiAzione();
            this.getQueryStandard();
            this.getReports();
        }
    },
};
</script>
<style scoped></style>
